import { TenantDTO } from 'probonio-shared-ui/api';
import { CircularProgressBar } from 'probonio-shared-ui/component/progress';
import { useTenant } from 'probonio-shared-ui/module/me';
import { useMemo } from 'react';
import { FullWidthCenterBox } from '../../../component/layout/BoxLayout';
import CarInfoPanel from './CarInfoPanel';

export interface BenefitPrecondition {
  isPreconditionMet: boolean;
  PreconditionComponent: React.ReactNode;
}

export function isCarPreconditionMet(tenant: TenantDTO | undefined): boolean {
  return !!tenant?.carCompanyCode;
}

export function useCarPrecondition(): BenefitPrecondition {
  const { tenant, isLoading } = useTenant();
  const isPreconditionMet = isCarPreconditionMet(tenant);

  const component = useMemo(
    () =>
      isLoading ? (
        <FullWidthCenterBox>
          <CircularProgressBar />
        </FullWidthCenterBox>
      ) : (
        <CarInfoPanel />
      ),
    [isLoading],
  );

  return useMemo(() => ({ isPreconditionMet, PreconditionComponent: component }), [component, isPreconditionMet]);
}
